import React, { Component } from 'react';
import Header from '../../Components/Header';
import {
  Linha,
  Container,
  DivDetalhe,
  ContainerWindowTitle,

  DivBaseKanbanTituloPai,
  DivBaseKanbanBase,
  DivBaseKanbanTitulo,
  DivBaseKanban,
  LinhaKanban,
  Kanban,
  KanbanContainer,

} from './styles';
import Dialog from '../../Components/@bit/Question';
import api from '../../services/api';
import { filtrarArray, alerta } from '../../services/funcoes';
import { getFromStorage } from '../../services/auth';
import DirectTituloJanela from '../../Components/@bit/DirectTituloJanela/index';
import { Icon } from 'react-materialize';

export default class NewsPortal extends Component {
  state = {
    loading: false,
  };

  /*INICIALIZACAO TELA*/
  async componentDidMount() {
    this.setState({ loading: true });
    await this.carregarVariaveisEstado();
    await this.loadPortalNews();
    await this.distributeNews();
    this.setState({ loading: false });
  }

  carregarVariaveisEstado = async (e) => {
    const sessao = getFromStorage();
    this.setState({
      empresaAtiva: sessao.empresaId,
      usuarioAtivo: sessao.codigoUsuario,
      empresaCfId: sessao.empresaCfId,
    });
  };

  handleChangeStatusNews = async (mensagem, ativo) => {
    try {
      let url = `/v1/portalnews/changestatus/`+mensagem.DNP_ID + '/'+ (ativo ? '1' : '0');

      const retorno = await api.get(url);
      if (!retorno) {
        this.setState({ portalNews: [] });
      } else {
        if (retorno.data && retorno.data.sucess) {
          this.setState({
            activeNews: filtrarArray(this.state.activeNews, mensagem),
          });
          this.setState({
            inactiveNews: [...this.state.inactiveNews, mensagem],
          });
          alerta('Novidade desativada com sucesso', 1);
        }
      }
    } catch (err) {
      alerta('Erro ao salvar o status da novidade =>' + err);
      this.setState({ loading: false });
    }
  }

  loadPortalNews = async () => {
    try {
      let url = `/v1/portalnews`;
      const retorno = await api.get(url);
      if (!retorno) {
        this.setState({ portalNews: [] });
      } else {
        if (retorno.data && retorno.data.sucess) {
          if (retorno.data.data.length === 0) {
            this.setState({ portalNews: [] });
          } else {
            this.setState({
              portalNews: retorno.data.data,
            });

          }
        } else {
          this.setState({ portalNews: [] });
        }
      }
    } catch (err) {
      alerta('Erro ao carregar a lista de book básico =>' + err);
      this.setState({ loading: false });
    }
  };

  distributeNews = () =>{
    const {portalNews}  = this.state;
    let activeNews = [];
    let inactiveNews = []

    portalNews !== undefined && portalNews.forEach((news)=>{
      if (news.DNP_FLG_STATUS_ID === 1){
        activeNews.push(news)
      } else {
        inactiveNews.push(news)
      }
    });

    this.setState({inactiveNews, activeNews});


  }

  render() {
    const {
      loading,
      activeNews,
      inactiveNews,
    } = this.state;
    return (
      <>
        <Header />
        <ContainerWindowTitle>
        <DirectTituloJanela
            urlVoltar={'/home'}
            titulo={loading ? 'Carregando...' : 'Novidades Portal'}
            urlNovo={'/newsportaladd/'}

          />
        </ContainerWindowTitle>
        <Container>
          <div
            style={{
              display: loading ? 'block' : 'none',
              position: 'absolute',
              height: '100vh',
              width: '100vw',
              top: '0px',
              left: '0px',
              backgroundColor: '#00000069',
              zIndex: '1',
            }}
          ></div>

          <Linha>
            <DivDetalhe>
            <LinhaKanban>
            <Kanban cor={'#2980b9'}>
              <DivBaseKanbanTituloPai cor={'#2980b9'}>
                :: Ativas
              </DivBaseKanbanTituloPai>
              <KanbanContainer>
                {activeNews !== undefined &&
                  activeNews.map((mensagem) => (
                    <>
                      <DivBaseKanban>
                        <DivBaseKanbanTitulo>
                          <span>
                            <strong>
                              {mensagem.DNP_ID +
                                ' - ' +
                                mensagem.DNP_ASSUNTO}
                            </strong>
                          </span>
                          <Dialog
                            iconeBotaoPadrao={
                              <span
                                style={{
                                  width: '10px!important',
                                  display: 'flex',
                                  color: 'rgb(97, 9, 138)',
                                  textTransform: 'capitalize',
                                }}
                              >
                                <Icon>delete</Icon>
                              </span>
                            }
                            classeBotaoPadrao="saib-button is-cancel"
                            textoBotaoPadrao=""
                            titulo="Você quer desativar esta novidade?"
                            tituloBotaoSim="Sim"
                            classeBotaoSim="saib-button is-primary modal-close"
                            tituloBotaoNao="Não"
                            classeBotaoNao="saib-button is-primary modal-close"
                            message={
                              <>
                                <div>
                                  <p>
                                    <strong>Código : </strong>
                                    {mensagem.DNP_ID}
                                  </p>
                                  <p>
                                    <strong>Assunto : </strong>
                                    {mensagem.DNP_ASSUNTO.toUpperCase()}
                                  </p>
                                  <br />
                                </div>
                              </>
                            }
                            onNo={() => {}}
                            onYes={async () => {
                              this.handleChangeStatusNews(mensagem, false);
                            }}
                          />
                        </DivBaseKanbanTitulo>
                        <DivBaseKanbanBase
                          style={{ margin: '0px 5px 10px 5px' }}
                        >
                          <button
                            title="Visualizar"
                            className="saib-button is-secondary"
                            style={{ display: 'flex', alignItems: 'center', width: 'auto' }}
                            onClick={async () => {
                              this.props.history.push(
                                '/newsportaladd/' + mensagem.DNP_ID
                              );
                            }}
                          >
                            <Icon>pageview</Icon> Ver
                          </button>
                        </DivBaseKanbanBase>
                      </DivBaseKanban>
                    </>
                  ))}
              </KanbanContainer>
            </Kanban>

            <Kanban cor={'#e74c3c'}>
              <DivBaseKanbanTituloPai cor={'#e74c3c'}>
                :: Inativas
              </DivBaseKanbanTituloPai>
              <KanbanContainer>
                {inactiveNews !== undefined &&
                  inactiveNews.map((mensagem) => (
                    <>
                      <DivBaseKanban>
                        <DivBaseKanbanTitulo>
                          <span>
                            <strong>
                              {mensagem.DNP_ID +
                                ' - ' +
                                mensagem.DNP_ASSUNTO}
                            </strong>
                          </span>
                        </DivBaseKanbanTitulo>
                        <DivBaseKanbanBase
                          style={{ margin: '0px 5px 10px 5px' }}
                        >
                          <button
                            title="Visualizar"
                            className="saib-button is-secondary"
                            style={{ display: 'flex', alignItems: 'center', width: 'auto' }}
                            onClick={async () => {
                              this.props.history.push(
                                '/newsportaladd/' + mensagem.DNP_ID
                              );
                            }}
                          >
                            <Icon>pageview</Icon> Ver
                          </button>
                        </DivBaseKanbanBase>
                      </DivBaseKanban>
                    </>
                  ))}
              </KanbanContainer>
            </Kanban>

            </LinhaKanban>

            </DivDetalhe>
          </Linha>
        </Container>
      </>
    );
  }
}
